import { ApplyWithSeekContext } from "./contexts/apply_with_seek_context";

interface Props {
  active: boolean;
  children: React.ReactNode;
}

export const ApplyWithSeek = ({ active, children }: Props) => {
  return (
    <ApplyWithSeekContext.Provider value={{ applyWithSeekEnabled: active }}>
      {children}
    </ApplyWithSeekContext.Provider>
  );
};
